'use client';

import {
  useState
} from 'react';

import
  dynamic
from 'next/dynamic';

import {
  SECONDARY_BUTTON_CLASSES
} from '@repo/ui/secondary-button';

// ssr: false for the same reason as careers/career-pdf-viewer.tsx: react-pdf
// pulls in pdf.js, which needs DOMMatrix at module scope, and this button is
// rendered by a server component (/support).
const DocumentViewerModal = dynamic(
  () => import('@repo/ui/document-viewer-modal'),
  {
    ssr: false
  }
);

// Served from the marketing app's own public/ folder, so the viewer's ranged
// fetches are same-origin (no CORS preflight - see apps/portal/next.config.js
// on iOS Safari).
export const COMPANY_BROCHURE_URL = '/documents/support/elite-scholars-sponsored-seats-for-companies.pdf';

// Opens the brochure in place (like a career advert's PDF) instead of handing
// it to the phone's own viewer and taking the reader off the page.
export default function BrochureButton() {

  const [ isOpen, setIsOpen ] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className={`inline-flex items-center justify-center px-7 py-3.5 ${ SECONDARY_BUTTON_CLASSES }`}
      >
        Company brochure (PDF)
      </button>

      {isOpen && (
        <DocumentViewerModal
          url={COMPANY_BROCHURE_URL}
          label="Sponsored seats for companies"
          mimeType="application/pdf"
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
